import { useEffect } from 'react';
export async function useEffectAsync(func, dependencies) {
    useEffect(() => {
        (async () => {
            await func();
        })();
    }, dependencies);
}
//# sourceMappingURL=reactHooks.js.map